import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserEnabledStatus } from "../services/authService";
import { Steps } from "antd";

function OnBoarding() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");
  const statusMap: any = {
    PENDING: "Pending",
    APPROVED: "Accepted",
    REJECTED: "Rejected",
  };
  useEffect(() => {
    if (
      localStorage.getItem("token") &&
      localStorage.getItem("token") != "null"
    ) {
      navigate("/dashboard");
    } else {
      getUserEnabledStatus().then((res: any) => {
        setStatus(res.data.status);
        if (res.data.status === "PENDING") {
          setMessage(
            "Thank you for your registration! Your request is being processed, and we will provide you with an update on its status shortly"
          );
          sessionStorage.setItem("fromApproval", "true");
        } else if (res.data.status === "REJECTED") {
          setMessage(res.data.message);
          sessionStorage.setItem("fromApproval", "true");
        } else {
          navigate("/auth/login");
        }
      });
    }
  }, []);
  return (
    <div className="flex">
      <div className="flex flex-col w-30v pw-height-100v pw-side-verify bg-neutral-800">
        <img
          className="h-10v object-contain mb-8"
          src="assets/images/logo.png"
          alt=" "
        />
        <Steps
          direction="vertical"
          current={1}
          size={"small"}
          className="pw-steps"
          items={[
            {
              title: "OTP Verfication",
            },
            {
              title: "Status",
            },
          ]}
        />
      </div>
      <div className="Section w-full h-full px-14 py-20 flex-col justify-start items-start gap-8 inline-flex">
        <div className="Section w-full h-full flex-col justify-start items-start gap-8 inline-flex">
          <div className="ApprovalPending w-full h-16 text-neutral-900 text-2xl font-bold pw-tab-label">
            Approval {statusMap[status]}
          </div>
          {status === "PENDING" && (
            <div className="w-[674px] h-10 text-neutral-700 text-sm font-normal leading-[21px]">
              {message}
            </div>
          )}
          {status === "REJECTED" && (
            <div className="w-[674px] h-10 text-neutral-700 text-sm font-normal leading-[21px] flex flex-col gap-8">
              <div>
                {
                  "We regret to inform you that your registration request has been denied due to the following reasons. Kindly, send the correct details to ‘customersupport@planetwise.io’ for the approval"
                }
              </div>
              <div>Reason: {message}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default OnBoarding;
